const LOCALSTORAGE_KEY = "codex-app-v2.5"

export default LOCALSTORAGE_KEY
